import { render } from "./App.vue?vue&type=template&id=6cc1b023"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6cc1b023&lang=css"

import exportComponent from "/home/runner/work/sharesight_partner_app/sharesight_partner_app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__